<template>
  <section id="search-results">
    <div class="container">
      <h1>Your Reservations</h1>
      <div class="row" v-if="reservationLists">
        <div class="col-lg-12">
          <div class="result" v-if="reservationLists.length" v-for="reservation of reservationLists">
            <div class="row">
              <div class="col-lg-5">
                <img :src="reservation.location_image" class="location-img" />
              </div><!-- end .col-lg-5 -->
              <div class="col-lg-7 pl-lg-0">
                <div class="resort-content">
                  <div class="row">
                    <div class="col-lg-9">
                      <h3 class="resort-title" v-html="reservation.location_name"></h3>
                      <p v-html="reservation.seat_display"></p>
                      <p v-html="reservation.visit_date_display"></p>
                    </div>
                    <div class="col-lg-3">
                      <span class="resort-city" v-html="reservation.amount_display"></span>
                    </div>
                  </div>
                </div><!-- end .resort-content -->
                <div class="pull-right">
                  <a class="btn btn-primary" :href="'#/reservations/confirmation/' + reservation.id + ''">Show</a>

                  <a class="btn btn-primary" href="javascript: void(0)" @click="cancelReservation(reservation)">Cancel</a>
                </div>
              </div><!-- end .col-lg-7 -->
            </div><!-- end .row -->
          </div><!-- end .result -->

          <div class="result" v-else>
            <div class="row">
              <div class="col-lg-12">
                <h1>Currently you do not have any reservation.</h1>
              </div>
            </div>
          </div>
        </div><!-- end .col-lg-12 -->
      </div><!-- end .row -->

    </div><!-- end .container -->
  </section>
</template>

<script>
import { getReservations, cancelReservation } from '@/api/reservation'
export default {
  name: 'reservationLists',
  data() {
    return {
      reservationLists: [],
      cancelAlertDialog: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      getReservations(this.userId).then(response => {
        if (response.data.success == true) {
          this.reservationLists = response.data.data;
        }
        this.loading = false
      })
    },
    /**
    * call when click the delete button
    * @param {Object} row each record
    * @return {void}
    */
    cancelReservation(row) {
      let refund = false
      let cancelMsg = ''
      let hours = Math.floor(Math.abs(+new Date() - +new Date(row.date_from)) / 36e5)
      if (hours > row.location_refund_within) {
        cancelMsg = 'As per our cancelation policy, we will refund your money.'
        refund = true
      } else {
        cancelMsg = 'As per our cancelation policy, we can not refund your money.'
        refund = false
      }

      if (cancelMsg) {
        this.$confirm(cancelMsg, 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          this.loading = true
          cancelReservation(row.id, {status: 'cancel', refund: refund}).then(response => {
            if (response.data.success === true) {
              this.flashSuccess(response.data.message)
              this.getList()
            }
            this.loading = false
          })
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?cd1aee6e